import { useIntl } from 'react-intl';
import InlineText from '../../InlineEdit/InlineText';
import InlineTextArea from '../../InlineEdit/InlineTextArea';
import messages from './messages';
import { imageScaleUrl } from '../../../helpers/imageScales';
import './lunchfeature.scss';

const View = (props: any) => {
  const intl = useIntl();
  const { data, isEditMode, block, onChangeBlock, imageSlot } = props;

  const update = (field: string, value: string) =>
    onChangeBlock(block, { ...data, [field]: value });

  const get = (field: string, message: any) =>
    data[field] ?? (isEditMode ? '' : intl.formatMessage(message));

  const eyebrow = get('eyebrow', messages.defaultEyebrow);
  const heading = get('heading', messages.defaultHeading);
  const body = get('body', messages.defaultBody);
  const formula = get('formula', messages.defaultFormula);
  const serviceInfo = get('service_info', messages.defaultServiceInfo);
  const priceNote = get('price_note', messages.defaultPriceNote);
  const menuNote = data.menu_note ?? '';
  const ctaLabel = get('cta_label', messages.defaultCtaLabel);
  const ctaHref = data.cta_href || '/carte';
  const hasMeta = Boolean(formula || serviceInfo || priceNote);
  const imageSide = data.image_side || 'right';

  const imageUrl =
    data.image && Array.isArray(data.image) && data.image.length > 0
      ? imageScaleUrl(data.image[0], 'great')
      : null;

  const defaultImageElement = imageUrl ? (
    <img
      src={imageUrl}
      alt={heading || intl.formatMessage(messages.defaultHeading)}
      loading="lazy"
    />
  ) : null;

  const slotted = imageSlot?.({
    fieldId: 'image',
    value: data.image,
    element: defaultImageElement,
  });

  const showImageWrap = Boolean(imageUrl) || Boolean(slotted);

  return (
    <section className="lunch" id="lunch">
      <div
        className={`shell lunch-inner${showImageWrap ? '' : ' lunch-inner--no-image'}${
          showImageWrap && imageSide === 'left'
            ? ' lunch-inner--image-left'
            : ''
        }`}
      >
        <div className="lunch-copy">
          {eyebrow &&
            (isEditMode ? (
              <p className="eyebrow">
                <InlineText
                  value={eyebrow}
                  onChange={(value) => update('eyebrow', value)}
                  renderTag="span"
                  placeholder={intl.formatMessage(messages.eyebrowPlaceholder)}
                />
              </p>
            ) : (
              <p className="eyebrow">{eyebrow}</p>
            ))}
          {heading &&
            (isEditMode ? (
              <h2>
                <InlineText
                  value={heading}
                  onChange={(value) => update('heading', value)}
                  renderTag="span"
                  placeholder={intl.formatMessage(messages.headingPlaceholder)}
                />
              </h2>
            ) : (
              <h2>{heading}</h2>
            ))}
          {body &&
            (isEditMode ? (
              <InlineTextArea
                value={body}
                onChange={(value) => update('body', value)}
                renderTag="p"
                placeholder={intl.formatMessage(messages.bodyPlaceholder)}
              />
            ) : (
              <p>{body}</p>
            ))}
          {hasMeta && (
            <dl className="lunch-meta">
              {formula && (
                <div>
                  <dt>{intl.formatMessage(messages.formulaLabel)}</dt>
                  <dd>
                    {isEditMode ? (
                      <InlineText
                        value={formula}
                        onChange={(value) => update('formula', value)}
                        renderTag="span"
                        placeholder={intl.formatMessage(
                          messages.formulaPlaceholder,
                        )}
                      />
                    ) : (
                      formula
                    )}
                  </dd>
                </div>
              )}
              {serviceInfo && (
                <div>
                  <dt>{intl.formatMessage(messages.serviceLabel)}</dt>
                  <dd>
                    {isEditMode ? (
                      <InlineText
                        value={serviceInfo}
                        onChange={(value) => update('service_info', value)}
                        renderTag="span"
                        placeholder={intl.formatMessage(
                          messages.serviceInfoPlaceholder,
                        )}
                      />
                    ) : (
                      serviceInfo
                    )}
                  </dd>
                </div>
              )}
              {priceNote && (
                <div>
                  <dt>{intl.formatMessage(messages.priceLabel)}</dt>
                  <dd className="price-accent">
                    {isEditMode ? (
                      <InlineText
                        value={priceNote}
                        onChange={(value) => update('price_note', value)}
                        renderTag="span"
                        placeholder={intl.formatMessage(
                          messages.priceNotePlaceholder,
                        )}
                      />
                    ) : (
                      priceNote
                    )}
                  </dd>
                </div>
              )}
            </dl>
          )}
          {menuNote &&
            (isEditMode ? (
              <InlineTextArea
                value={menuNote}
                onChange={(value) => update('menu_note', value)}
                renderTag="p"
                renderClassName="lunch-note"
                placeholder={intl.formatMessage(messages.menuNotePlaceholder)}
              />
            ) : (
              <p className="lunch-note">{menuNote}</p>
            ))}
          {ctaLabel && (
            <div className="lunch-actions">
              {isEditMode ? (
                <span className="btn btn-primary lunch-action-preview">
                  <InlineText
                    value={ctaLabel}
                    onChange={(value) => update('cta_label', value)}
                    renderTag="span"
                    placeholder={intl.formatMessage(
                      messages.ctaLabelPlaceholder,
                    )}
                  />
                  <span className="arrow" aria-hidden="true">
                    →
                  </span>
                </span>
              ) : (
                <a className="btn btn-primary" href={ctaHref}>
                  {ctaLabel}
                  <span className="arrow" aria-hidden="true">
                    →
                  </span>
                </a>
              )}
            </div>
          )}
        </div>
        {showImageWrap && (
          <div className="lunch-img-wrap">{slotted ?? defaultImageElement}</div>
        )}
      </div>
    </section>
  );
};

export default View;
